import { StoreCore, createStore } from "@priolo/jon";
import { NATSClose, NATSConnect } from "plugins/nats";
import farmSo from "stores/farm";
import growUnitSo from "stores/growUnit";
import { startChannelRuby, stopChannelRuby } from "stores/growUnit/utils/channel";
import layoutSo from "stores/layout";
import parentsSo from "stores/mainMenu/parents";
import sectionsSo from "stores/mainMenu/sections";
import { getByPageId, isChild, setItemMenu } from "stores/mainMenu/utils";
import metaSo from "stores/metadata";
import { getPLCAlertsByComponentCode, updatePLCAlerts } from "stores/plc/utils/alerts/utils";
import userSo from "stores/user";
import { Nats } from "types/Service";
import querySo from "./query";
import { PAGE_ID } from "./utils/types";



const isPLC = import.meta.env.VITE_TARGET == "plc"

/**
 * gestisce la posizione in cui l'APP si trova nella struttura delle varie pagine
 */
const setup = {

	state: {
		// la PAGE-ID visibile in questo momento
		currentPage: <PAGE_ID>null,
		/** la PAGE-ID precedente */
		previousPage: <PAGE_ID>null,
	},

	getters: {
	},

	actions: {
		/** chiamata dalla pagina quando è renderizzata */
		updatePageId: (pageId: PAGE_ID, store?: LocationStore) => {
			const { parents, sections, index } = getByPageId(pageId) ?? {}

			// se è una cambio INTERNO aggiorno il QUERY-URL
			if (!!store.state.currentPage) querySo.updateQueryUrl()

			updateFarm(pageId)
			updateComponent(pageId)

			// se si torna indietro cancello eventuali "overwriting" sul parent
			if (isChild(store.state.currentPage, pageId)) parentsSo.setOverwritePage(null)

			// TODO: è sbagliato devo trovare anche se è una pagina in profondità di un tabs per esempio
			if (!sections) {
				store.setCurrentPage(pageId)
				return
			}

			// MAIN MENU and HEADER
			sectionsSo.select(index)
			sectionsSo.update(sections)
			parentsSo.update(parents)

			layoutSo.setTitle("")
			store.setCurrentPage(pageId)
		},
	},

	mutators: {
		/** permette di settare l'attuale pagina visualizzata */
		setCurrentPage: (currentPage: PAGE_ID, store?: LocationStore) => {
			return { currentPage, previousPage: store.state.currentPage }
		},
	},
}

export type LocationState = typeof setup.state
export type LocationGetters = typeof setup.getters
export type LocationActions = typeof setup.actions
export type LocationMutators = typeof setup.mutators
export interface LocationStore extends StoreCore<LocationState>, LocationGetters, LocationActions, LocationMutators {
	state: LocationState
}
const locationSo = createStore(setup) as LocationStore
export default locationSo



/** su cambio pageId si occupa del cambio di FARM */
function updateFarm(pageId: PAGE_ID) {

	// è all'interno di una contest FARM (oppure nel PLC)
	if (isChild(pageId, PAGE_ID.FARMS) || isPLC) {

		let cred: { username: string, password: string } = null
		if (!isPLC && !!userSo.state.current?.natsCredentials && !!farmSo.state.select) {
			const userCred = userSo.state.current.natsCredentials.find(nc => nc.farmId == farmSo.state.select.id)
			cred = {
				username: userCred?.username?.length > 0 ? userCred?.username : userCred?.readOnlyUsername,
				password: userCred?.password?.length > 0 ? userCred?.password : userCred?.readOnlyPassword,
			}
		}

		// connessione a NATS se sono in PLC-CONSOLE oppure in ZERO-OS e ho user/psw...
		if (isPLC || (!!cred?.username && !!cred?.password)) {
			const config = farmSo.state.select.edgeServicesConfig
			const conf: Nats = {
				...farmSo.isInCloud() ? config.cloud_nats : config.nats,
				...cred
			}
			NATSConnect(conf, () => {
				metaSo.fetchIfVoid(farmSo.state.select?.edgeServicesConfig?.host?.url);
			})
		} else {
			NATSClose()
		}

		// siamo nella FARM VIRTUALE quindi non resettare la farm
	} else if (farmSo.state.select?.id == 0 && (pageId == PAGE_ID.LABS_PLANNER || pageId == PAGE_ID.LABS_SOLUTIONS)) {


		// è fuori dall'area dei FARM
	} else {
		farmSo.setSelect(null)
		growUnitSo.state.lastFarmId = null
		NATSClose()
	}
}

let intGUUpdateId = null

/** su cambio pageId si occupa del cambio di COMPONENT */
function updateComponent(pageId: PAGE_ID) {

	// è all'interno di dell'area dei COMPONENTs
	if (isChild(pageId, PAGE_ID.FARM_GROWUNITS)) {

		// mi connetto al canale ruby della growunit selezionata (se è cambiata) per ricevere i dati in real-time
		startChannelRuby(growUnitSo.state.select?.id)

		// aggiorno gli ALERTS regolarmente
		if (!!intGUUpdateId) window.clearInterval(intGUUpdateId)
		updateMenuAlerms()
		intGUUpdateId = window.setInterval(() => {
			updateMenuAlerms()
		}, 5000)

		// è fuori dall'area dei COMPONENTs
	} else {

		// disconnetto eventuale canale ruby
		stopChannelRuby()

		// resetto eventuali interval per aggiornamento
		window.clearInterval(intGUUpdateId)
		intGUUpdateId = null
		unsubscribeMenuAlarms()

		growUnitSo.setSelect(null)
		farmSo.setComponentSelect(null)
	}

}

function updateMenuAlerms() {
	const alerts = updatePLCAlerts(getPLCAlertsByComponentCode(farmSo.state.componentSelect?.code))
	const alertsNumLabel = !alerts.length ? null : alerts.length.toString()
	setItemMenu(PAGE_ID.GROWUNIT_PLC_ALERTS, { badge: alertsNumLabel })
}

function unsubscribeMenuAlarms() {
	setItemMenu(PAGE_ID.GROWUNIT_PLC_ALERTS, { badge: null })
}
